export const NEWSPAPER_ORDER = ['lepq', 'mquo', 'actu', 'aeco', 'mlwk', 'week', 'woch', 'sema', 'mquovideo', 'actuvideo', 'mlne', 'mwne', 'acne'];

export  const VIDEONEWSPAPERS = { mquovideo: 'mquo', actuvideo: 'actu' };

export function sharedItems(newspaperSubname: string): string[] {
  if (newspaperSubname === 'mquo' || newspaperSubname === 'lepq' || newspaperSubname === 'mlwk' || newspaperSubname === 'mlne' || newspaperSubname === 'mquovideo') {
    return ['email'];
  }

  if (newspaperSubname === 'week' || newspaperSubname === 'woch' || newspaperSubname === 'sema') {
    return ['facebook', 'email'];
  }

  if (newspaperSubname === 'actu' || newspaperSubname === 'aeco' || newspaperSubname === 'mwne' || newspaperSubname === 'actuvideo') {
    return ['facebook','twitter','email','whatsapp'];
  }

  return [];
}

export function formatDatePublish(dateString: string): Date {
  const date_parts = dateString.split('/');
  const day = parseInt(date_parts[0], 10);
  const month = parseInt(date_parts[1], 10) - 1;
  let year = parseInt(date_parts[2], 10);
  if (year > 70) {
    year += 1900;
  } else {
    year += 2000;
  }
  return new Date(year, month, day);
}

export function newspaperPdfOrder(a, b) {
  if (a.newspaper_subname) {
    return NEWSPAPER_ORDER.indexOf(a.newspaper_subname) - NEWSPAPER_ORDER.indexOf(b.newspaper_subname);
  } else {
    return NEWSPAPER_ORDER.indexOf(a) - NEWSPAPER_ORDER.indexOf(b);
  }
}

export function formatDateFromCalendar(date: any) {
  if (!date) {
    return null;
  }

  return date.year + '-' + (date.month < 10 ? `0${date.month}` : date.month) + '-' + (date.day < 10 ? `0${date.day}` : date.day);
}

export const UIUPopUpNoShow = [
  '/article/la-liberte-dexpression-2024-12-18-172634',
  '/article/qui-est-charlie-hebdo-2024-12-18-172658',
  '/article/la-liberte-de-la-presse-2024-12-18-172613',
  '/article/peut-on-rire-de-tout-2024-12-18-163541',
  '/article/charlie-hebdo-un-symbole-de-la-liberte-dexpression-2024-12-18-172658',
  '/article/faut-il-limiter-la-liberte-dexpression-2024-12-18-172634',
  '/article/la-liberte-dinformer-est-elle-en-danger-2024-12-18-172613',
  '/article/lattentat-de-charlie-hebdo-la-france-en-etat-de-choc-2024-12-18-163454',
  '/article/charlie-hebdo-un-symbole-de-la-liberte-dexpression-2024-12-18-172658',
  '/article/faut-il-limiter-la-liberte-dexpression-2024-12-18-172634',
];

export const replaceWithNbspBeforeArray = [
  "!",
  "&LAQUO;",
  "&RAQUO;",
  "&laquo;",
  "&raquo;",
  ":",
  ";",
  "?",
  "ANS",
  "AOÛT",
  "AVRIL",
  "DÉCEMBRE",
  "FÉVRIER",
  "JANVIER",
  "JUILLET",
  "JUIN",
  "KM",
  "MAI",
  "MARS",
  "NOVEMBRE",
  "OCTOBRE",
  "SEPTEMBRE",
  "ans",
  "Ans",
  "août",
  "Août",
  "avril",
  "Avril",
  "décembre",
  "Décembre",
  "février",
  "Février",
  "janvier",
  "Janvier",
  "juillet",
  "Juillet",
  "juin",
  "Juin",
  "km",
  "Km",
  "mai",
  "Mai",
  "mars",
  "Mars",
  "novembre",
  "Novembre",
  "octobre",
  "Octobre",
  "septembre",
  "Septembre",
  "«",
  "»"
]
